import React from "react";
import PrettyDate from "./PrettyDate";
import {tdStyles} from "./tableStyles";
import Direction from "./Direction";
import {validityPeriodToDisplay, valueOrEmDash} from "../../common/displayUtils";

const FullHistoryRow = (props) => (
    <tr>
        <td style={Object.assign({}, tdStyles, {width: "100px"})}><PrettyDate date={props.disseminatedOn} /></td>
        <td style={tdStyles}>{props.isin}</td>
        <td style={tdStyles}>{props.companyName}</td>
        <td style={tdStyles}><Direction direction={props.direction} derivativeDescription={props.derivativeDescription}/></td>
        <td style={tdStyles}>{valueOrEmDash(props.targetPrice)}</td>
        <td style={tdStyles}>{valueOrEmDash(props.marketPrice.price)}</td>
        <td style={tdStyles}>{valueOrEmDash(validityPeriodToDisplay(props.validityPeriod))}</td>
    </tr>
);
FullHistoryRow.propTypes = {
    companyName: React.PropTypes.string,
    disseminatedOn: React.PropTypes.string,
    isin: React.PropTypes.string,
    direction: React.PropTypes.string,
    derivativeDescription: React.PropTypes.string,
    targetPrice: React.PropTypes.string,
    marketPrice: React.PropTypes.shape({
        source: React.PropTypes.string,
        price: React.PropTypes.string
    }).isRequired,
    validityPeriod: React.PropTypes.string
};
FullHistoryRow.defaultProps = {
    marketPrice: {
        source: null,
        price: null
    }
};

export default FullHistoryRow;



/** WEBPACK FOOTER **
 ** ./src/main/javascript/disclosure/components/FullHistoryRow.js
 **/